angular.module('storefront.account')
    .component('rsGuestOrderStatus', {
        templateUrl: 'themes/assets/js/account/rsGuestOrderStatus.tpl.html',
        controller: ['rsOrderService', function (orderApi) {
            const ctrl = this;

            ctrl.searchOrder = function () {
                ctrl.isLoading = true;
                orderApi.searchGuestCustomerOrders({
                    email: ctrl.email,
                    orderNumber: ctrl.orderNumber,
                }).then(function (response) {
                    ctrl.entries = response.data.results;
                    ctrl.isLoading = false;
                });
            };

            ctrl.submit = function () {
                ctrl.searchOrder();
            };
        }],
    });
